/**
 * continuum-lite — Continuum Lite, one Windows box per customer (a8 lite install,
 * FEATURE-20261016-continuum-single-server-on-windows). One build serves every
 * Lite customer: its database is the one a8 lite install creates from the
 * schema embedded in a8.exe, so the model (generated/lite/) is the same on every
 * box. The app lands on chat; the nav drops what a Lite box does not run
 * (checkpoint programs, jobs and schedules, the mesh and demo pages). Filesets
 * stay: Lite runs the checkpoint compiler, and a box's rag pipeline is a fileset
 * (FEATURE-20261029-rag-extract-dwg-and-msg).
 */
import type { CustomerProfile } from "@/customer/profile";
import { pagesByName } from "@/customer/profile";
import type { PageModule } from "@/page-dsl/spec";
import { ROUTES } from "@/routes/paths";

const profile: CustomerProfile = {
  id: "continuum-lite",
  name: "Continuum",
  home: ROUTES.LOOM.CHAT,
  nav: {
    items: [],
    hideCategories: ["Demos", "Mesh"],
    hidePaths: [
      ROUTES.PAGE.FOR("jobs"),
      ROUTES.PAGE.FOR("schedules"),
      ROUTES.APP.DASHBOARD,
      ROUTES.PAGE.FOR("checkpoint-run"),
      ROUTES.CHECKPOINT.SAVED,
      ROUTES.PAGE.FOR("program-runs"),
      ROUTES.PAGE.FOR("monitors"),
      ROUTES.APP.REGISTRY,
      ROUTES.PAGE.FOR("workers"),
      ROUTES.PAGE.FOR("alert-channels"),
    ],
  },
  pages: pagesByName(import.meta.glob<PageModule>("./pages/*.page.ts")),
};

export default profile;
